var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7965 4.20019L4.97733 0.946021C4.65233 0.571021 4.0565 0.572688 3.679 0.951021L1.36066 3.27352C0.670662 3.96435 0.473162 4.99019 0.872329 5.81269C3.25663 10.7504 7.23877 14.7381 12.1732 17.1294C12.9948 17.5285 14.0198 17.331 14.7098 16.6402L17.0498 14.296C17.429 13.9169 17.4298 13.3177 17.0515 12.9927L13.7848 10.1885C13.4432 9.89519 12.9123 9.93352 12.5698 10.2769L11.4332 11.4152C11.3751 11.4764 11.2985 11.5168 11.2152 11.5301C11.1319 11.5433 11.0465 11.5287 10.9723 11.4885C9.11444 10.4185 7.57325 8.87531 6.50566 7.01602C6.46526 6.94175 6.45055 6.85621 6.46382 6.77272C6.47708 6.68922 6.51757 6.61245 6.579 6.55435L7.71233 5.42019C8.05566 5.07519 8.09316 4.54269 7.7965 4.20019Z",
    stroke: "#DCDCEC",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.11451c3d59b6f6bc27b2614b4a7dabce.svg";
export { ForwardRef as ReactComponent };